<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M24.666 11.333v16H7.333V4.666H18v3a3.667 3.667 0 003.65 3.667h3.016zm-.828-2l-1.92-1.92L20 5.495v2.172c0 .917.74 1.661 1.656 1.667h2.182zm-18.505-5c0-.92.746-1.667 1.667-1.667h12.31c.441 0 .865.176 1.178.488L23.333 6l2.845 2.846c.313.312.488.736.488 1.178v17.643c0 .92-.746 1.667-1.666 1.667H7c-.92 0-1.667-.746-1.667-1.667V4.333z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'filesFile'
}
</script>
